import { Operation } from 'rfc6902';
import { apply_patch } from 'jsonpatch';

/**
 * Applies the given JSONPatch using the given initial state.
 * The given object is not mutated but a new object version of the object is
 * returned instead. Throws an error if the patch cannot be applied.
 * @param obj initial state of the object
 * @param patch JSONPatch to apply
 * @returns new object with the patch applied
 */
export default function applyPatch<T>(obj: T, patch: Operation[]): T {
  return apply_patch(obj, patch);
}
